import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyHotelDetails = loadable(() => import(/* webpackChunkName: "content/hotel/details" */ './HotelDetails'), 'HotelDetails');
